export default obj => {
   if (obj && obj.meta) {
      const meta = {
         title: obj.meta.header,
         meta: [
            {
               name: 'description',
               content: obj.meta.description,
            },
            {
               name: 'keywords',
               content: obj.meta.keywords,
            },
            {
               vmid: 'og:title',
               property: 'og:title',
               content: obj.meta.headerSocial,
            },
            {
               property: 'og:type',
               vmid: 'og:type',
               content: obj.meta.image && obj.meta.image.type,
            },
            {
               property: 'og:site_name',
               vmid: 'og:site_name',
               content: 'Fusioncharts.com',
            },
            {
               property: 'og:description',
               vmid: 'og:description',
               content: obj.meta.descriptionSocial,
            },
            {
               property: 'og:image',
               vmid: 'og:image',
               content: obj.meta.image && obj.meta.image.rasterSource.file.url,
            },
            {
               property: 'og:url',
               vmid: 'og:url',
               content: obj.canonical || 'https://www.fusioncharts.com',
            },
         ],
      };

      // ✅ add canonical only if passed
      if (obj.canonical) {
         meta.link = [
            {
               rel: 'canonical',
               href: obj.canonical,
            },
         ];
      }

      return meta;
   }

   return {};
};
